import { render, staticRenderFns } from "./TheAside.vue?vue&type=template&id=f47772fa&scoped=true&"
import script from "./TheAside.vue?vue&type=script&lang=js&"
export * from "./TheAside.vue?vue&type=script&lang=js&"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./TheAside.vue?vue&type=style&index=1&id=f47772fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f47772fa",
  null
  
)

export default component.exports